exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".UpdateOpeningTicketInstructionPanel-openingTicketPurposes-1tM4R{border-top:1px solid #dadada}.UpdateOpeningTicketInstructionPanel-openingTicketPurposes-1tM4R .UpdateOpeningTicketInstructionPanel-action-JN8qk{margin:20px 0 0;text-align:right}.UpdateOpeningTicketInstructionPanel-openingTicketPurposes-1tM4R .UpdateOpeningTicketInstructionPanel-action-JN8qk button{padding:5px}.UpdateOpeningTicketInstructionPanel-openingTicketPurposes-1tM4R ul{margin:0;padding:0;list-style-type:none}", ""]);

// exports
exports.locals = {
	"openingTicketPurposes": "UpdateOpeningTicketInstructionPanel-openingTicketPurposes-1tM4R",
	"action": "UpdateOpeningTicketInstructionPanel-action-JN8qk"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/message/components/UpdateOpeningTicketInstructionPanel.less
// module id = 1672
// module chunks = 0